import { render, staticRenderFns } from "./wizard-welcome.vue?vue&type=template&id=1859c053&scoped=true&lang=pug"
import script from "./wizard-welcome.vue?vue&type=script&lang=ts"
export * from "./wizard-welcome.vue?vue&type=script&lang=ts"
import style0 from "./wizard-welcome.vue?vue&type=style&index=0&id=1859c053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1859c053",
  null
  
)

export default component.exports